module.exports = "<p>\r\n  player-detail works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/player-detail/player-detail.component.html
// module id = ./src/app/player-detail/player-detail.component.html
// module chunks = main